import { useMemo } from "react";
import { buildDeviceInfo } from "../utilities/tachographDeviceInfo";
import { useDiagnosticsBySearch } from "@/hooks/diagnostic/useDiagnosticsBySearch";
import { useTachographDeviceStatusData } from "@/hooks/tachograph/useTachographDeviceStatusData";

const DIAGNOSTIC_LIMIT = 500;

const MANUFACTURER_DIAGNOSTIC = /^Tachograph manufacturer/i;

const CALIBRATION_DIAGNOSTIC = /^Tachograph next calibration/i;

/** What each vehicle's tachograph says about itself: its make and its next calibration. */
export function useTachographDeviceInfo(deviceIds: string[]) {
  const { data: diagnostics = [] } = useDiagnosticsBySearch("Tachograph", false, DIAGNOSTIC_LIMIT);

  const diagnosticIds = useMemo(
    () => ({
      manufacturerId: diagnostics.find(entry => MANUFACTURER_DIAGNOSTIC.test(entry.name ?? ""))?.id,
      calibrationId: diagnostics.find(entry => CALIBRATION_DIAGNOSTIC.test(entry.name ?? ""))?.id,
    }),
    [diagnostics],
  );

  const wanted = useMemo(
    () =>
      [diagnosticIds.manufacturerId, diagnosticIds.calibrationId].filter(
        (id): id is string => !!id,
      ),
    [diagnosticIds],
  );

  const { data: statusData = [] } = useTachographDeviceStatusData(deviceIds, wanted);

  return useMemo(() => buildDeviceInfo(statusData, diagnosticIds), [statusData, diagnosticIds]);
}
